import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { emailTemplatesService } from '../services/emailService';
import { Spinner } from 'react-bootstrap';

const TemplateSelector = ({ value, onChange, disabled = false }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState({});

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await emailTemplatesService.getAllTemplates({ isActive: true });
        
        if (response.status && response.data) {
          setTemplates(response.data);
          
          // Group by category
          const grouped = {};
          response.data.forEach(template => {
            if (!grouped[template.category]) {
              grouped[template.category] = [];
            }
            grouped[template.category].push(template);
          });
          setCategories(grouped);
        }
      } catch (err) {
        console.error('Error fetching templates:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  if (loading) {
    return (
      <Form.Group className="mb-3">
        <Form.Label>Email Template</Form.Label>
        <div className="d-flex align-items-center gap-2">
          <Spinner size="sm" />
          <span className="text-muted">Loading templates...</span>
        </div>
      </Form.Group>
    );
  }

  return (
    <Form.Group className="mb-3">
      <Form.Label>Email Template</Form.Label>
      <Form.Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        disabled={disabled}
      >
        <option value="">None (Custom Email)</option>
        {Object.keys(categories).map(category => (
          <optgroup key={category} label={category.charAt(0).toUpperCase() + category.slice(1)}>
            {categories[category].map(template => (
              <option key={template.id} value={template.code}>
                {template.name}
              </option>
            ))}
          </optgroup>
        ))}
      </Form.Select>
      {error && (
        <Form.Text className="text-danger">
          {error}
        </Form.Text>
      )}
      <Form.Text className="text-muted">
        Select a template to auto-populate email content, or leave blank for a custom email.
      </Form.Text>
    </Form.Group>
  );
};

export default TemplateSelector;

